import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { HomepageBlock6 as Block } from "./HomepageBlock6";
import { defaultData } from "./HomepageBlock6DefaultData";
import { meta } from "./HomepageBlock6MetaData";
import imagePreview from "./homepage_block_6_preview.png";

export const HomepageBlock6: BlockExport = {
  type: "component",
  Block,
  imagePreview: {
    type: "image-url",
    lg: imagePreview,
  },
  defaultData,
  meta,
};
